import { render } from "./PanelistData.vue?vue&type=template&id=0144fc5b"
import script from "./PanelistData.vue?vue&type=script&lang=js"
export * from "./PanelistData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/michaelhu/GWS/GitLab/onemeasure/web/panel360/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__